module.exports = __webpack_public_path__ + "img/4.2a78e962.png";